import { AlreadyLoggedInGuard } from "./shared/guards/already-logged-in.guard";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthLayoutSimpleComponent } from "./shared/components/layouts/auth-layout-simple/auth-layout-simple.component";
import { AuthLayoutComponent } from "./shared/components/layouts/auth-layout/auth-layout.component";
import { AuthGuard } from "./shared/services/auth.guard";
import { BlankLayoutComponent } from "./shared/components/layouts/blank-layout/blank-layout.component";
import { AdminLayoutSidebarLargeComponent } from "./shared/components/layouts/admin-layout-sidebar-large/admin-layout-sidebar-large.component";
import { FormCompleteComponent } from "./views/register/form-complete/form-complete.component";
import { FormCompleteTwoComponent } from "./views/register/form-complete/form-complete-two/form-complete-two.component";
import { FormTreeComponent } from "./views/register/form-complete/form-tree/form-tree.component";

const adminRoutes: Routes = [
  {
    path: "dashboard",
    loadChildren: () =>
      import("./views/dashboard/dashboard.module").then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: "customer",
    loadChildren: () =>
      import("./views/customers/customers.module").then(
        (m) => m.CustomersModule
      ),
  },
  {
    path: "parameters",
    loadChildren: () =>
      import("./views/parameters/parameters.module").then(
        (m) => m.ParametersModule
      ),
  },
  {
    path: "requests",
    loadChildren: () =>
      import("./views/requests/requests.module").then((m) => m.RequestsModule),
  },
  {
    path: "users",
    loadChildren: () =>
      import("./views/users/users.module").then((m) => m.UsersModule),
  },
  {
    path: "my-profile",
    loadChildren: () =>
      import("./views/my-profile/my-profile.module").then(
        (m) => m.MyProfileModule
      ),
  },
  {
    path: "terms-conditions",
    loadChildren: () =>
      import("./views/terms-conditions/terms-conditions.module").then(
        (m) => m.TermsConditionsModule
      ),
  },
  {
    path: "customers-list",
    loadChildren: () =>
      import("./views/customers-list/customers-list.module").then(
        (m) => m.CustomersListModule
      ),
  },

  {
    path: "intern-frm",
    loadChildren: () =>
      import("./views/intern-form/intern.module").then((m) => m.InternModule),
  },

  {
    path: "list-request",
    loadChildren: () =>
      import("./views/list-request/list-request.module").then(
        (m) => m.ListRequestModule
      ),
  },
  {
    path: "calculadora",
    loadChildren: () =>
      import("./views/calculator/calculator.module").then(
        (m) => m.CalculatorModule
      ),
  },
];

const routes: Routes = [
  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "21",
        canLoad: [AlreadyLoggedInGuard],
        loadChildren: () =>
          import("./views/sessions/sessions.module").then(
            (m) => m.SessionsModule
          ),
      },
    ],
  },
  {
    path: "sessions",
    component: AuthLayoutSimpleComponent,
    children: [
      {
        path: "ses",
        canLoad: [AlreadyLoggedInGuard],
        loadChildren: () =>
          import("./views/sessions/sessions.module").then(
            (m) => m.SessionsModule
          ),
      },
    ],
  },
  {
    path: "form",
    component: AuthLayoutSimpleComponent,
    children: [
      {
        path: "in",
        canLoad: [AlreadyLoggedInGuard],
        loadChildren: () =>
          import("./views/extern-form/extern.module").then(
            (m) => m.ExternModule
          ),
      },
    ],
  },
  // {
  //   path: "form-cc",
  //   component: FormCompleteComponent,
  // },
  // {
  //   path: "form-natural",
  //   component: FormCompleteTwoComponent,
  // },

  {
    path: "unete",
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./views/register/form-complete/form.module").then(
            (m) => m.FormModule
          ),
      },
    ],
  },

  {
    path: "form-juridica",
    component: FormTreeComponent,
  },
  {
    path: "register",
    component: AuthLayoutSimpleComponent,
    children: [
      {
        path: "reg",
        canLoad: [AlreadyLoggedInGuard],
        loadChildren: () =>
          import("./views/register/register.module").then(
            (m) => m.SessionsModule
          ),
      },
    ],
  },

  {
    path: "",
    component: AdminLayoutSidebarLargeComponent,
    canActivate: [AuthGuard],
    children: adminRoutes,
  },

  /*{
    path: '',
    component: AuthLayoutComponent,
    
  },
  {
    path: '',
    children: [
      {
        path: 'sessions',
        canLoad: [AlreadyLoggedInGuard],
        loadChildren: () => import('./views/sessions/sessions.module').then(m => m.SessionsModule)
      }
    ]
  },*/

  {
    path: "**",
    redirectTo: "others/404",
  },
  {
    path: "lost",
    loadChildren: () =>
      import("./views/others/others.module").then((m) => m.OthersModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
